import {
  BookOpenIcon,
  ClipboardCheckIcon,
  Clock3Icon,
  FilesIcon,
  FlaskConicalIcon,
  LayersIcon,
  LeafIcon,
  PencilLineIcon,
  PrinterIcon,
  SproutIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '12', label: 'VOLUMI COMPLETI' },
  { value: '726+', label: 'PAGINE DI CONTENUTO' },
  { value: '17', label: 'RISORSE INCLUSE' },
  { value: '100%', label: 'PRONTO DA STAMPARE' },
]

export const transformationStats: Stat[] = [
  { value: '726+', label: 'PAGINE PRONTE DA USARE' },
  { value: '12', label: 'VOLUMI COMPLETI' },
  { value: '100%', label: 'VERIFICHE INCLUSE' },
]

export const beforeItems: string[] = [
  'Passi ore a cercare materiale sparso online',
  'Le lezioni di scienze sono improvvisate all’ultimo minuto',
  'Non hai attività pratiche pronte, solo teoria da un libro',
  'Correggere le verifiche ti ruba le serate',
  'Non sai se stai coprendo davvero il programma dell’anno',
]

export const afterItems: string[] = [
  'Tutto il materiale è già pronto, organizzato per classe e unità',
  'Ogni lezione ha una struttura chiara passo dopo passo',
  'Attività pratiche, schede ed esperimenti pronti da stampare',
  'Criteri di correzione rapidi inclusi in ogni volume',
  'Programmazione annuale già mappata su tutte le classi',
]

export interface PainPoint {
  icon: LucideIcon
  title: string
  text: string
}

export const painPoints: PainPoint[] = [
  {
    icon: Clock3Icon,
    title: 'Poco tempo per preparare le lezioni',
    text: 'Tra correzioni, riunioni e la vita fuori da scuola, restano pochi minuti per preparare una lezione di scienze davvero coinvolgente.',
  },
  {
    icon: FilesIcon,
    title: 'Materiale sparso e incoerente',
    text: 'Fogli trovati online, fotocopie di anni fa, niente che segua davvero una progressione chiara da una classe all’altra.',
  },
  {
    icon: FlaskConicalIcon,
    title: 'Poche attività pratiche pronte',
    text: 'Tanta teoria, pochi esercizi nuovi e pronti da stampare per far consolidare davvero i concetti.',
  },
  {
    icon: PencilLineIcon,
    title: 'Correzioni che si accumulano',
    text: 'Ogni verifica corretta a mano è tempo sottratto alla tua famiglia e al tuo riposo.',
  },
]

export interface KitItem {
  icon: LucideIcon
  title: string
  description: string
}

export const kitContents: KitItem[] = [
  {
    icon: BookOpenIcon,
    title: '10 Volumi Completi',
    description: 'Un libro per ogni classe, dalla 1ª Primaria alla 3ª Secondaria di primo grado',
  },
  {
    icon: LeafIcon,
    title: '726+ Pagine di Curriculum',
    description: 'Teoria, attività e verifiche già scritte e pronte',
  },
  {
    icon: SproutIcon,
    title: 'Attività Passo Dopo Passo',
    description: 'Ogni unità segue una struttura chiara, facile da seguire',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Verifiche e Griglie di Valutazione',
    description: 'Criteri di correzione rapidi inclusi in ogni volume',
  },
  {
    icon: FlaskConicalIcon,
    title: 'Attività Pratiche ed Esperimenti',
    description: 'Non solo teoria: schede operative ed esperimenti da fare in classe',
  },
  {
    icon: LayersIcon,
    title: 'Coerenza dalla Primaria alla Secondaria',
    description: 'Una progressione unica, senza ripetizioni tra un anno e l’altro',
  },
]

export const instantAccessItems: string[] = [
  'I 10 volumi completi, per alunni dai 6 ai 14 anni',
  'Teoria, attività pratiche e verifiche in ogni volume',
  'Istruzioni semplici, passo dopo passo',
  'Materiale già pronto da stampare o usare in digitale',
  '2 PDF di attività extra inclusi, pronti da stampare',
  'Non ti mancherà mai materiale per una lezione',
]

export const printReadyIcon: LucideIcon = PrinterIcon
